import { Component, Input } from '@angular/core';
import { RegistroPrecos } from 'eddydata-lib';
import { BaseLicitacaoAudesp } from '../../util/base-licitacao-audesp';
//import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-licitacao-audesp-prequalificacao',
  templateUrl: './licitacao-audesp-prequalificacao.component.html'
})
export class LicitacaoAudespPrequalificacaoComponent extends BaseLicitacaoAudesp {

  @Input() public entidade: RegistroPrecos;

  constructor(
  ) {
    super()
  }
}
